import { IconProps } from '.';

const HomePlansIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142903)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7471 29.333V1.83301H16.2471V29.333H13.7471Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2474 0.833008C14.6918 0.499674 15.303 0.499674 15.7474 0.833008L29.0807 10.833C29.3955 11.0691 29.5807 11.4396 29.5807 11.833V29.333C29.5807 30.0234 29.0211 30.583 28.3307 30.583H1.66406C0.973707 30.583 0.414062 30.0234 0.414062 29.333V11.833C0.414062 11.4396 0.599305 11.0691 0.914062 10.833L14.2474 0.833008ZM2.91406 12.458V28.083H27.0807V12.458L14.9974 3.39551L2.91406 12.458Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3304 18.9163H14.9971V16.4163H28.3304V18.9163Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142903">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HomePlansIcon;
